import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import WhyVisit from "@/components/home/WhyVisit";
import TopDestinations from "@/components/home/TopDestinations";
import PopularTours from "@/components/home/PopularTours";
import WhyChoose from "@/components/home/WhyChoose";
import HomeTestimonials from "@/components/home/HomeTestimonials";
import TravelInspiration from "@/components/home/TravelInspiration";
import HomeFaq from "@/components/home/HomeFaq";
import HomeOffices from "@/components/home/HomeOffices";
import CtaBanner from "@/components/home/CtaBanner";
import { getHomepage } from "@/lib/api";

export default function Home() {
  const [home, setHome] = useState(null);

  useEffect(() => {
    getHomepage().then(setHome).catch(() => setHome({}));
  }, []);

  const sec = (key) => home?.sections?.find((s) => s.key === key) || {};
  const visible = (key) => (home?.sections ? (sec(key).visible !== false) : true);

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    name: "Legacy India Travel",
    description: "Tailor-made luxury India tours for travellers around the world.",
    areaServed: "Worldwide",
    address: {
      "@type": "PostalAddress",
      streetAddress: "78, Block F-1, Taj Nagri Phase 2",
      addressLocality: "Agra",
      postalCode: "282001",
      addressRegion: "Uttar Pradesh",
      addressCountry: "IN",
    },
    telephone: "+91 80773 85030",
    email: "haseeb@legacyindiatravel.com",
  };

  return (
    <>
      <Seo
        title="Legacy India Travel | Discover India, Experience Extraordinary"
        description="Discover Incredible India with Legacy India Travel — tailor-made luxury tours across Rajasthan, Kerala, Kashmir, the Golden Triangle and beyond. Trusted by travellers around the world. Enquire now."
        schema={orgSchema}
      />
      <Hero home={home} />
      <Marquee />
      {visible("why_visit") && <WhyVisit title={sec("why_visit").title} subtitle={sec("why_visit").subtitle} items={home?.why_visit || []} />}
      {visible("destinations") && <TopDestinations title={sec("destinations").title} subtitle={sec("destinations").subtitle} />}
      {visible("tours") && <PopularTours title={sec("tours").title} subtitle={sec("tours").subtitle} />}
      {visible("why_choose") && <WhyChoose title={sec("why_choose").title} subtitle={sec("why_choose").subtitle} items={home?.why_choose || []} />}
      {visible("testimonials") && <HomeTestimonials title={sec("testimonials").title} subtitle={sec("testimonials").subtitle} />}
      {visible("blog") && <TravelInspiration />}
      {visible("faq") && <HomeFaq title={sec("faq").title} subtitle={sec("faq").subtitle} />}
      {visible("offices") && <HomeOffices title={sec("offices").title} subtitle={sec("offices").subtitle} />}
      <CtaBanner title={home?.cta_title} subtitle={home?.cta_subtitle} />
    </>
  );
}
